<div class="col col-12">
  <h1>Offset Payments</h1>
  <p>Select the ‘i’ icon for information and guidance on how to use this page. If you require assistance, email <a href="mailto:bcfpayments@bct.nsw.gov.au">bcfpayments@bct.nsw.gov.au</a></p>
  <div class="card">
    <div data-toggle="collapse" class="pointer" data-target="#searchBox" role="button" aria-expanded="false"
         aria-controls="searchBox" aria-hidden="true" appAccordionDefaultOpenIcons>
      <h4 class="card-header accordion-up">
        Quotes<span class="pull-right mr-3">          
          <i class="fa fa-arrow-up icon-info" aria-hidden="true">
          </i>
        </span>
      </h4>
    </div>
    <div class="card-body accordion-collapse collapse show" id="searchBox">
      <form [formGroup]="fgSearch" novalidate class="row">
        <div class="col-md-6 form-group">
          <button class="btn btn-primary" (click)="createNewApplication();">Create new application</button>
           <span class="p-2"><tooltip register="External" tab="Offsets Payment" section="Quotes" field="Create New Application"></tooltip></span>
        </div>
      </form>
      <div class="row mt-2 ml-1 align-items-center">
        <h6 class="mb-0">Quotes summary table</h6><span class="p-2"><tooltip register="External" tab="Offsets Payment" section="Quotes" field="Quotes"></tooltip></span>
      </div>

      <div class="row ml-1">
        <span>Select and open a Quote No.</span>
      </div>
      <div class="row mt-2">
        <ag-grid-angular #quoteSummaryGrid style="width: 100%; height: 500px;"
          [getRowStyle]="pinnedRowStyle"
          class="ag-theme-alpine"
          [rowData]="quoteData"
          [columnDefs]="quoteGridColumns"
          [pagination]="true"
          [defaultColDef]="defaultColDef"
          (cellClicked)="onSelectQuoteItem($event.data);">
        </ag-grid-angular>
      </div>
    </div>
  </div>

  <div class="mt-2">
    <!--Payments-->
    <div class="card">
      <div data-toggle="collapse" class="pointer" data-target="#paymentsDiv" role="button" aria-expanded="false"
           aria-controls="paymentsDiv" aria-hidden="true" appAccordionDefaultOpenIcons>
        <h4 class="card-header accordion-up">
          BCF Payments<span class="pull-right mr-3">            
            <i class="fa fa-arrow-up icon-info" aria-hidden="true"></i>
          </span>
        </h4>
      </div>
      <div id="paymentsDiv" class="card-body accordion-collapse collapse show">
        <div class="row ml-3 align-items-center">
          <h6 class="mb-0">BCF Payments summary table</h6><span class="p-2"><tooltip register="External" tab="Offsets Payment" section="BCF Payments" field="BCF Payments"></tooltip></span>
        </div>
        <div class="row ml-3">
          <span>Select and open a Payment No.</span>
        </div>
        <ag-grid-angular #paymentSummaryGrid style="width: 100%; height: 500px;"
          [getRowStyle]="pinnedRowStyle"
          class="ag-theme-alpine"
          [rowData]="paymentsData"
          [columnDefs]="paymentGridColumns"
          [pagination]="true"
          [defaultColDef]="defaultColDef"
          (cellClicked)="onSelectPaymentItem($event.data);">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  <app-quote #quoteComponent></app-quote>
  <app-payment #paymentComponent></app-payment>
</div>


